import { Actions as TaskNotificationsCountActions } from '../actions/fetchTasksCount';
import { Actions as ReportingNotificationsCountActions } from '../actions/fetchReportingNotificationsCount';
import { Actions as SafetyProgramsNotificationsCountActions } from '../actions/fetchSafetyProgramsNotificationsCount';
import { Actions as FetchEsignatureDocumentsNotificationsCountActions } from '../actions/fetchEsignatureDocumentsCount';
import { Actions as ChangeOrganizationProfileNotifications } from '../actions/changeOrganizationProfileNotifications';
import { Actions as SubcontractRequestsCount } from '../actions/fetchSubcontractsRequestsCount';
import { Actions as ClientSubcontractsCount } from '../actions/fetchClientSubcontractsCount';
import { Actions as NotificationRecipientsCount } from '../actions/fetchNotificationRecipients';
import { DeepReadonly } from 'utility-types';
import { IOrganizationProfileStatus } from '../interfaces/organizationProfileNotifications';
import { Actions as PendingReleasesNotificationsActions } from '../actions/fetchPendingReleasesCount';
import { Actions as FetchPendingCoursesAndProgramsCountActions } from '../actions/fetchPendingCoursesAndProgramsCount';

export type State = DeepReadonly<{
  tasks: number | null;
  flexTrack: number | null;
  operationalReporting: number | null;
  safetyPrograms: number | null;
  esignatureDocuments: number | null;
  incomingSubcontractRequests: number | null;
  clientSubcontracts: number | null;
  notificationRecipients: number | null;
  organizationProfile: IOrganizationProfileStatus;
  pendingReleasesCount: number | null;
  pendingCoursesAndProgramsCount: number | null;
}>;

export const initialState: State = {
  tasks: null,
  flexTrack: null,
  operationalReporting: null,
  safetyPrograms: null,
  esignatureDocuments: null,
  incomingSubcontractRequests: null,
  clientSubcontracts: null,
  notificationRecipients: null,
  organizationProfile: {
    contactInformationSection: {
      contactsIsCompleted: null,
      addressIsCompleted: null
    },
    operationDetailsSection: {
      companyNameIsCompleted: null,
      businessSummaryIsCompleted: null,
      organizationTypeIsCompleted: null,
      employeeCountIsCompleted: null,
      operationRegionsIsCompleted: null,
      naicsIsCompleted: null,
      industriesIsCompleted: null,
      servicesIsCompleted: null,
      serviceCategoriesIsCompleted: null,
      allServicesMatchBusinessType: null,
      connectedClientIndustries: null,
      connectedClientServiceCategories: null,
      operatingRegionsV2IsCompleted: null
    },
    hiringClientSection: {
      requestConnectionsIsCompleted: null,
      reviewIncomingIsCompleted: null
    }
  },
  pendingReleasesCount: null,
  pendingCoursesAndProgramsCount: null
};

type Actions =
  | TaskNotificationsCountActions
  | ReportingNotificationsCountActions
  | SafetyProgramsNotificationsCountActions
  | FetchEsignatureDocumentsNotificationsCountActions
  | ChangeOrganizationProfileNotifications
  | SubcontractRequestsCount
  | ClientSubcontractsCount
  | NotificationRecipientsCount
  | PendingReleasesNotificationsActions
  | FetchPendingCoursesAndProgramsCountActions;

export function reducer(state: State = initialState, action: Actions): State {
  switch (action.type) {
    case 'FETCH_TASKS_COUNT_SUCCESS':
      return {
        ...state,
        tasks: action.payload
      };
    case 'FETCH_REPORTING_NOTIFICATIONS_COUNT_SUCCESS':
      return {
        ...state,
        flexTrack: action.flexTrackCount,
        operationalReporting: action.operationsCount
      };
    case 'FETCH_SAFETY_PROGRAMS_COUNT_SUCCESS':
      return {
        ...state,
        safetyPrograms: action.payload
      };
    case 'FETCH_ESIGNATURE_DOCUMENTS_COUNT_SUCCESS':
      return {
        ...state,
        esignatureDocuments: action.payload
      };
    case 'CHANGE_ORGANIZATION_PROFILE_NOTIFICATIONS':
      return {
        ...state,
        organizationProfile: {
          ...state.organizationProfile,
          ...action.payload
        }
      };
    case 'FETCH_INCOMING_SUBCONTRACT_REQUESTS_COUNT_SUCCESS':
      return {
        ...state,
        incomingSubcontractRequests: action.payload
      };
    case 'FETCH_CLIENT_SUBCONTRACTS_COUNT_SUCCESS':
      return {
        ...state,
        clientSubcontracts: action.payload
      };
    case 'FETCH_NOTIFICATION_RECIPIENT_COUNT_SUCCESS':
      return {
        ...state,
        notificationRecipients: action.payload
      };
    case 'FETCH_PENDING_RELEASES_COUNT_SUCCESS':
      return {
        ...state,
        pendingReleasesCount: action.payload
      };
    case 'FETCH_PENDING_COURSES_AND_PROGRAMS_COUNT_SUCCESS':
      return {
        ...state,
        pendingCoursesAndProgramsCount: action.payload
      };
    default:
      return state;
  }
}
